// In AuthContext.js
import { createContext, useContext, useState, useEffect } from 'react';
import { onAuthStateChanged, signOut } from 'firebase/auth';
import { auth } from './firebase.js';
import { loadPatrolId, setCurrentUid, setPatrolId } from './api.js';

const AuthContext = createContext();

const signOutUser = async () => {
    setPatrolId(null);
    setCurrentUid(null);
    await signOut(auth);
};

export const AuthProvider = ({ children }) => {
    const [ currentUser, setCurrentUser ] = useState(null);
    const [ token, setToken ] = useState(null);

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, user => {
            if (user) {
                user.getIdTokenResult().then((tokenResult) => {
                    // Expose the token immediately; never block login on the profile fetch.
                    setToken(tokenResult);

                    // Best effort, not awaited: learn the patrol id for x-patrol-id. Failures are ignored.
                    setCurrentUid(user.uid);
                    loadPatrolId(user.uid, tokenResult.token);
                });
            } else {
                setPatrolId(null);
                setCurrentUid(null);
                setToken(null);
            }

            setCurrentUser(user);
        });

        return unsubscribe;
    }, []);

    return (
        <AuthContext.Provider value={ { auth, currentUser, token: token?.token, claims: token?.claims, signOutUser } }>
            { children }
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);